import * as React from 'react';
import { StyleSheet } from 'react-native';
import { useAuth } from '../auth/Auth';
import QRCode from 'qrcode.react'

import { View } from '../components/Themed';
export default function TabOneScreen() {

  const {status, user} = useAuth()

  return (
    <View style={styles.container}>
      <QRCode value={user?.mnumber ? user.mnumber : ''} size={250} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#0fa8e4ff',
    alignItems: 'center',
    justifyContent: 'center',
    height: 400
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: '80%',
  },
});

const logo = `
<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   width="150mm"
   height="150mm"
   viewBox="0 0 46.413879 45.360279"
   version="1.1"
   id="svg860"
   inkscape:version="1.0.1 (0767f8302a, 2020-10-17)"
   sodipodi:docname="pedoz-logo-swirl.svg">
  <defs
     id="defs854" />
  <sodipodi:namedview
     id="base"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageopacity="0.0"
     inkscape:pageshadow="2"
     inkscape:zoom="0.35"
     inkscape:cx="-242.30635"
     inkscape:cy="552.68763"
     inkscape:document-units="mm"
     inkscape:current-layer="layer1"
     inkscape:document-rotation="0"
     showgrid="false"
     fit-margin-top="0"
     fit-margin-left="0"
     fit-margin-right="0"
     fit-margin-bottom="0"
     inkscape:window-width="1515"
     inkscape:window-height="995"
     inkscape:window-x="50"
     inkscape:window-y="0"
     inkscape:window-maximized="0" />
  <metadata
     id="metadata857">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-2.1221278,-1.9347304)">
    <path
       style="fill:#274283;fill-opacity:1;stroke-width:0.566854"
       d="m 21.108853,46.666363 c -6.69237,-1.87386 -9.94104,-6.40478 -10.39194,-14.49371 -0.56171,-10.07666 4.25747,-16.93083 12.87649,-18.31382 6.197979,-0.99452 11.653804,1.17822 14.353084,5.71601 2.73221,4.59317 1.52851,12.83931 -2.6453,18.12189 l -1.52139,1.92554 1.78723,-1.09305 c 3.13795,-1.91913 7.89219,-6.78563 9.67434,-9.90276 2.49743,-4.36822 2.45165,-8.92113 -0.12575,-12.51796 -3.57928,-4.99485 -10.68078,-7.7803398 -19.860774,-7.7901698 -6.57181,-0.008 -11.01495,1.39219 -15.00983,4.7269198 -4.2107098,3.51492 -5.7097598,6.81559 -6.5160498,14.34743 -0.9287,8.67542 -2.01718,7.85114 -1.45074,-1.09862 0.48836,-7.7161 1.4334,-11.01477 4.33606,-15.13512 3.31867,-4.7108698 7.0036398,-7.1009798 13.3885898,-8.6839298 8.27698,-2.05204602 21.004794,1.97862 25.508414,8.0780598 2.43414,3.29663 2.96366,5.2954 3.02264,11.40928 0.0613,6.35006 -1.22442,10.31657 -4.92532,15.19539 -6.13272,8.08467 -14.681794,11.69763 -22.499674,9.50862 z m -2.70178,-8.32093 c -1.89369,-3.09134 -1.91743,-10.03505 -0.0467,-13.62162 2.15904,-4.13898 7.34142,-5.44725 10.6836,-2.69705 1.414299,1.16377 1.715519,1.85559 1.715519,3.94006 0,1.39064 -0.162989,2.52844 -0.36227,2.52844 -0.199269,0 -1.06208,-0.47282 -1.917429,-1.0507 -1.68297,-1.13702 -5.02881,-1.38319 -6.92893,-0.50977 -1.4527,0.66776 -3.02436,3.18818 -3.02436,4.85004 0,0.68222 0.57692,1.77226 1.28202,2.42231 4.7766,4.40363 13.436964,1.72578 17.037694,-5.26817 1.80432,-3.50467 0.25332,-6.3264 -4.54145,-8.26219 -7.464034,-3.01342 -15.709754,-0.0441 -19.308104,6.9529 -1.53856,2.99176 -1.286,5.21206 0.97306,8.55464 1.144639,1.69366 4.52957,4.32555 5.6396,4.38498 0.0909,0.004 -0.45012,-0.99587 -1.20236,-2.22387 z"
       id="path81" />
  </g>
</svg>

`
